import React, { FC } from "react";
import { StudentEngagementStackedLineChartCard } from "./StudentEngagementStackedLineChartCard";


export interface StudentEngagementChartCardProps {
    title?: React.ReactNode;
    extra?: React.ReactNode;
    defaultFilters?: { [key: string]: (string | number | string[] | number []) }
}

export const StudentEngagementChartCard: FC<StudentEngagementChartCardProps> = ({title, extra, defaultFilters}) => {
    return <StudentEngagementStackedLineChartCard title={title} defaultFilters={defaultFilters} extra={extra}/>
}